export const OFFLINE_ERROR_MESSAGE_KEY = "NUTRITION_COMMON_ERR_NO_INTERNET";

export const isOffline = () =>
  typeof navigator !== "undefined" && navigator.onLine === false;

export const resolveUserSubmitErrorMessage = (
  err,
  { fallback, translate, offlineKey = OFFLINE_ERROR_MESSAGE_KEY } = {}
) => {
  if (isOffline()) {
    const offlineMessage = translate?.(offlineKey);
    return offlineMessage && offlineMessage !== offlineKey
      ? offlineMessage
      : "No internet connection. Please check your network and try again.";
  }

  const responseMessage = err?.response?.data?.message;
  if (responseMessage) {
    return responseMessage;
  }

  const message = err?.message;
  if (message?.startsWith?.("NUTRITION_")) {
    const translated = translate?.(message);
    return translated && translated !== message ? translated : message;
  }

  return message || fallback || "";
};
